
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.46 12.36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f8bf13","d":"M9.46 3.09v6.05c0 1.78-1.44 3.22-3.21 3.22h-.09c-.77 0-1.51-.31-2.06-.85L.26 7.71a.753.753 0 01.5-1.32c.11 0 .22.02.32.07l2.12.97V2.04c0-.53.43-.96.96-.97.18 0 .33.14.33.32v4.22c0 .07.06.13.13.13h.02c.07 0 .13-.06.13-.13V.78A.783.783 0 016.11.23c.14.14.23.34.23.55v4.44c0 .08.06.14.13.14h.02c.08 0 .14-.06.14-.14V.97c0-.1.08-.18.19-.18.3 0 .57.13.77.32.2.2.32.48.32.78V5.6c0 .08.06.14.13.14h.02c.07 0 .13-.06.13-.14V2.24c0-.12.1-.22.22-.22.59 0 1.06.47 1.06 1.06z"}})])
          )
        }
      }
    